module.exports = __webpack_public_path__ + "media/images/google_profile-bd111327.jpg";